// src/plugins/twitterTrack.js

export default {
  install(Vue, options = {}) {
    // 默认的事件 ID，可以在 main.js 中通过 options 覆盖
    const defaultEventId = options.eventId || 'tw-qhx3x-qn85v'

    // 在 Vue 原型上挂载一个全局方法
    const trackTwitter = function(eventId = defaultEventId) {
      if (window.twq) {
        window.twq('event', eventId, {})
        console.log(`✅ Twitter conversion tracking triggered: ${eventId}`)
      } else {
        console.warn('⚠️ Twitter tracking not available, retrying...')
        setTimeout(() => {
          if (window.twq) {
            window.twq('event', eventId, {})
            console.log(`✅ Retried Twitter conversion tracking: ${eventId}`)
          }
        }, 1000)
      }
    }
     // 挂载到 Vue 原型
    Vue.prototype.$twitterTrack = trackTwitter
    
    // 也作为全局方法提供
    Vue.twitterTrack = trackTwitter
  }
}
